export const Education = [
  {value: 0, slug: 'analfabeto', label: 'Analfabeto'},
  {value: 1, slug: '5_ano_fundamental_incompleto', label: 'Até o 5º ano Incompleto do Ensino Fundamental'},
  {value: 2, slug: '5_ano_fundamental_completo', label: '5º ano Completo do Ensino Fundamental'},
  {value: 3, slug: '6_9_fundamental_incompleto', label: 'Do 6º ao 9º ano do Ensino Fundamental Incompleto'},
  {value: 4, slug: 'fundamental_completo', label: 'Ensino Fundamental Completo'},
  {value: 5, slug: 'medio_incompleto', label: 'Ensino Médio Incompleto'},
  {value: 6, slug: 'medio_completo', label: 'Ensino Médio Completo'},
  {value: 7, slug: 'superior_incompleto', label: 'Educação Superior Incompleta'},
  {value: 8, slug: 'superior_completo', label: 'Educação Superior Completa'},
  {value: 9, slug: 'pos_graduacao', label: 'Pós-graduação'},
  {value: 10, slug: 'especializacao', label: 'Especialização'},
  {value: 11, slug: 'mestrado', label: 'Mestrado Completo'},
  {value: 12, slug: 'doutorado', label: 'Doutorado Completo'},
  {value: 13, slug: 'phd', label: 'Ph.D'},
];
